import {LocationIcon} from '../../../icons/LocationIcon';
import {MapContainer, Marker, TileLayer} from 'react-leaflet';
import {Icon} from 'leaflet';
import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import './BookingInitialAside.scss';
import {InfoTextsDialog} from 'src/components/info-texts/info-texts-dialog/InfoTextsDialog';
import {useInfoTextsContext} from 'src/context/InfoTextsContext';
import {InfoTextsControl} from 'src/components/info-texts/InfoTextsControl';
import {useLocationDetailsContext} from 'src/context/LocationDetailsContext';

export function BookingInitialAside() {
    const {t} = useTranslation();
    const {
        locationDataState: {location, loading, error}
    } = useLocationDetailsContext();
    const [position, setPosition] = useState<[number, number]>();
    const [showFullTextToggle, setShowFullTextToggle] = useState<boolean>(false);

    const {infoTextsState} = useInfoTextsContext();
    const {infoTexts} = infoTextsState;

    const getMapsUrl = () => {
        if (navigator.userAgent.indexOf('Mac') !== -1) {
            return `maps://maps.apple.com/?q=${location?.address.split(' ').join('')},${location?.city
                .split(' ')
                .join('')}`;
        } else {
            return `https://maps.google.com/maps/search/?api=1&query=${location?.address
                .replace(' ', '+')
                .split(' ')
                .join('')}+${location?.city.split(' ').join('')}`;
        }
    };

    const mapServiceEndpoint =
        process.env.REACT_APP_CLINIC_MAP_SERVICE_ENDPOINT || 'https://maps-test.mittvaccin.se/tile';

    const hiddenWelcomeText = (text: string | undefined, showFullTextToggle: boolean) => {
        if (text && text.length > 320 && showFullTextToggle) {
            return text.substring(0, 300).concat('...');
        }
        return text;
    };

    useEffect(() => {
        if (location?.position?.lat && location?.position?.lon) {
            setPosition([location.position.lat as number, location.position.lon as number]);
            if (location?.information && location?.information.length > 320) {
                setShowFullTextToggle(true);
            }
        }
    }, [location]);

    return (
        <aside className='aside-content' aria-label={location ? t('clinic_aside.aria_label') : ''}>
            {loading && !error && <div className='aside-content__loading'></div>}
            {!loading && location && !error && (
                <div className='aside-content__container aside-content__container--initial'>
                    <InfoTextsDialog />

                    {infoTexts?.length > 0 && (
                        <section className='aside-padding info_texts_wrapper'>
                            <h3>{t('clinic_aside.info_texts')}</h3>
                            <InfoTextsControl />
                        </section>
                    )}

                    <section className='aside-padding'>
                        <h3>{t('clinic_aside.welcome')}</h3>
                        <p className='wrap-html'>
                            {hiddenWelcomeText(location?.information, showFullTextToggle)}{' '}
                            {showFullTextToggle && (
                                <button className='primary' onClick={() => setShowFullTextToggle(!showFullTextToggle)}>
                                    {t('clinic_aside.read_more')}
                                </button>
                            )}
                        </p>
                    </section>

                    <section className='contact-us'>
                        <h3 className='aside-padding'>{t('clinic_aside.find_location')}</h3>
                        <div className='links'>
                            <p>
                                {location?.address && (
                                    <a href={getMapsUrl()}>
                                        <LocationIcon />
                                        {location?.address + `, ` + location?.city + ` ` + location?.zip}
                                    </a>
                                )}
                            </p>
                        </div>
                    </section>
                    {position && (
                        <div className='aside-map'>
                            <MapContainer
                                className='map_container'
                                center={position}
                                zoom={15}
                                scrollWheelZoom={false}
                                dragging={false}
                            >
                                <TileLayer
                                    attribution='<span aria-hidden="true" >&copy; <a href="https://www.openstreetmap.org/copyright" tabindex=-1>OpenStreetMap</a> contributors</span>'
                                    url={`${mapServiceEndpoint}/{z}/{x}/{y}.png`}
                                />
                                <Marker
                                    alt={t(`map_position_marker.text`) as string}
                                    position={position}
                                    icon={
                                        new Icon({
                                            className: 'position_map_marker',
                                            iconUrl: '/map_pin_bus.png',
                                            iconSize: [48, 56]
                                        })
                                    }
                                />
                            </MapContainer>
                        </div>
                    )}
                </div>
            )}
        </aside>
    );
}
